// /school/* layout, web half (FR-008, FR-014, FR-015, FR-043; routes.md rules 3-4). The guard runs
// first; only an allowed school-admin session renders the lazy layout, so parents and signed-out
// visitors never request the school-admin chunk.
import type { ComponentType } from "react";

import { lazyScreen } from "@/shell/lazyScreen";
import { RouteGuard } from "@/shell/RouteGuard";

const LazySchoolAdminLayout = lazyScreen<object>(() =>
  import("@/school-admin/screens").then((m) => ({
    default: m.SchoolAdminLayout as ComponentType<object>,
  })),
);

export default function SchoolLayoutWeb() {
  return (
    <RouteGuard area="school">
      <LazySchoolAdminLayout />
    </RouteGuard>
  );
}

// A screen that throws shows the themed fallback (FR-041; US6-2).
export { ErrorFallback as ErrorBoundary } from "@/shell/ErrorFallback";
